import React from "react";
import styles from "./css/Header.module.css";

export const LoginHeader: React.FC = () => {
  return (
    <>
      <header className={styles.headerContainer}>
        <div className={styles.centerContent}>
          <img
            src="/Images/logoLetters.png"
            alt="Forward Logo"
            className={styles.logoImgLarge}
          />
        </div>
      </header>
      <div className={styles.darkBar}></div>
    </>
  );
};